import { Injectable } from '@angular/core';
import { EventEmitter } from '../lib/event-emitter';

@Injectable({
    providedIn: 'root'
})
export class UIGlobalEvent extends EventEmitter {}
